import { Link, useLocation } from 'react-router-dom';
import { ROUTES, SECTION } from '../routes.js';
import { scrollToHash } from '../lib/scrollToHash.js';
import './Positioning.css';

const YES_ITEMS = [
  {
    title: 'Ihr persönlicher Einkäufer',
    text: 'Wir arbeiten im Auftrag des Käufers. Ihre Interessen sind unsere einzigen Interessen.',
  },
  {
    title: 'Pre Market Scouting',
    text: 'Wir identifizieren Objekte, bevor sie öffentlich zum Verkauf stehen – oder die nie öffentlich werden.',
  },
  {
    title: 'Recherche & Vor-Ort-Check',
    text: 'Eigentümer-Recherche, Kataster, Foto- und Videomaterial, Nachbarschaftsanalyse – alles manuell.',
  },
  {
    title: 'Direkter Draht zum Eigentümer',
    text: 'Wir klopfen in Ihrem Namen an. Sie erscheinen als vorbereiteter Investor, nicht als Bittsteller.',
  },
  {
    title: 'Transparentes Fix-Honorar',
    text: 'Ein klar definiertes Scouting-Honorar, das Sie zahlen. Keine Erfolgsprovision vom Verkäufer.',
  },
];

const NO_ITEMS = [
  {
    title: 'Kein Immobilienmakler',
    text: 'Wir vermitteln nicht zwischen Parteien. Wir beschaffen für eine Seite – Ihre.',
  },
  {
    title: 'Keine Doppelprovision',
    text: 'Wir nehmen niemals Geld vom Verkäufer. Interessenkonflikte sind strukturell ausgeschlossen.',
  },
  {
    title: 'Kein Inserat-Portal',
    text: 'Wir betreiben keine Plattform, keine Datenbank für die Öffentlichkeit. Unsere Arbeit ist 1:1.',
  },
  {
    title: 'Kein Bieterkampf',
    text: 'Sie konkurrieren nicht mit zehn anderen Interessenten. Sie sind der Einzige, der es weiß.',
  },
  {
    title: 'Kein Massengeschäft',
    text: 'Wir nehmen wenige Mandate pro Zone gleichzeitig an. Qualität vor Durchsatz.',
  },
];

export default function Positioning() {
  const { pathname } = useLocation();

  const handleAnchor = (e, hash) => {
    if (pathname !== ROUTES.home) return;
    e.preventDefault();
    scrollToHash(hash);
    window.history.replaceState(null, '', `#${hash}`);
  };

  return (
    <section className="positioning" id="positionierung" aria-label="Positionierung – Was wir sind, was wir nicht sind">
      <div className="container positioning__inner">
        <div className="positioning__head">
          <span className="eyebrow">
            <span className="eyebrow__dot" /> Klare Worte
          </span>
          <h2 className="positioning__title">
            Kein Makler. Keine Plattform.
            <br />
            <span className="positioning__title-accent">
              Ihre eigene Off-Market-Einheit.
            </span>
          </h2>
          <p className="positioning__lead">
            Damit es keine Missverständnisse gibt – hier steht Schwarz auf Weiß,
            was wir für Sie tun und was wir bewusst nicht sind.
          </p>
        </div>

        <div className="positioning__grid">
          <article className="position-card position-card--yes">
            <header className="position-card__head">
              <span className="position-card__badge position-card__badge--yes">
                Das sind wir
              </span>
              <h3 className="position-card__title">
                Pre Market Scout – exklusiv für Sie.
              </h3>
            </header>
            <ul className="position-list">
              {YES_ITEMS.map((item, i) => (
                <li key={i} className="position-item">
                  <span className="position-item__icon position-item__icon--yes" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <div className="position-item__body">
                    <strong>{item.title}</strong>
                    <span>{item.text}</span>
                  </div>
                </li>
              ))}
            </ul>
          </article>

          <article className="position-card position-card--no">
            <header className="position-card__head">
              <span className="position-card__badge position-card__badge--no">
                Das sind wir nicht
              </span>
              <h3 className="position-card__title">
                Wir sind kein Makler – und genau das ist der Punkt.
              </h3>
            </header>
            <ul className="position-list">
              {NO_ITEMS.map((item, i) => (
                <li key={i} className="position-item">
                  <span className="position-item__icon position-item__icon--no" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                    </svg>
                  </span>
                  <div className="position-item__body">
                    <strong>{item.title}</strong>
                    <span>{item.text}</span>
                  </div>
                </li>
              ))}
            </ul>
          </article>
        </div>

        <div className="positioning__cta">
          <Link
            to={`${ROUTES.home}#${SECTION.kontakt}`}
            onClick={(e) => handleAnchor(e, SECTION.kontakt)}
            className="btn-primary positioning__cta-btn"
          >
            Kostenloses Kennenlernen
            <svg className="arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="13 6 19 12 13 18" />
            </svg>
          </Link>
          <span className="positioning__cta-note">
            30 Min · unverbindlich · diskret
          </span>
        </div>
      </div>
    </section>
  );
}
